package com.example.mystybag.appCore.model.pages

import com.example.mystybag.sharedmodels.project.database.UserReservationModel

data class LeaveReviewUIState(
    val reservation: UserReservationModel,
    val ratingCollectionExperience: Int = 0,
    val ratingFoodQuality: Int = 0,
    val ratingVarietyOfContents: Int = 0,
    val ratingFoodQuantity: Int = 0,
    val reviewCategories: List<ReviewRatingCategory> = emptyList(),
    /** Selected "could be better" aspect ids (enum names). Max 3. */
    val selectedCouldBeBetterAspectIds: Set<String> = emptySet(),
    /** Optional comment, max 200 characters. */
    val comment: String = "",
    val isSubmittingReview: Boolean = false,
    val isReviewSubmitted: Boolean = false,
    val isError: Boolean = false,
    val errorMessage: String = ""
)
